import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createClient } from '@supabase/supabase-js';
import { SessionContextProvider } from '@supabase/auth-helpers-react';
import { HelmetProvider } from "react-helmet-async";

const supabase = createClient(
  "https://cujppahoknhafgbezulu.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN1anBwYWhva25oYWZnYmV6dWx1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzM5NzM5NzQsImV4cCI6MjA0OTU0OTk3NH0.qtLexPPci6-bNGUySn5PVfrVpeveZLLt-fX_AZOTGZI" 
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SessionContextProvider supabaseClient={supabase}>
    <HelmetProvider>
        <App />
      </HelmetProvider>
    </SessionContextProvider>
  </React.StrictMode>
);

reportWebVitals();
